import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { ApplyTemplateDTO } from "@dto/dashboard.dto";
import AbstractDashboardSelect, { DashboardSelect, DashboardSelectProps } from "@parts/dashboard/select/AbstractDashboardSelect";
import { MenuDataNode } from "@parts/dashboard/select/DashboardContextMenu";
import { isAxiosError } from "axios";
import { postApi } from "src/util/apiCalls";
import { API_URL } from "../../data/Api";
import { Log } from "../../service/log.service";

interface SummaryDashboardSelectProps extends DashboardSelectProps {
  /** Item the summary template is built from. */
  itemId: string;
}

/**
 * Adds the summary template of the current item to whole dashboards.
 * The target group and its graphs are created by the backend, so only dashboards are selectable.
 */
export default class SummaryDashboardSelect extends AbstractDashboardSelect<SummaryDashboardSelectProps> {

  protected get noGroup() { return true; }
  protected get grafanaEnabled() { return false; }
  protected get itemLabel() { return 'summary'; }
  protected override showLegendCheckbox = true;

  protected postToDashboard(ds: DashboardSelect, dash: MenuDataNode) {
    return postApi<BasicResponseDTO, ApplyTemplateDTO>(API_URL.DASHBOARD + '/template',
      { dashboard_id: dash.itemId, item_id: this.props.itemId, legend: ds.legend })
      .then(() => undefined, reason => {
        Log.error(isAxiosError<BasicResponseDTO>(reason) && reason.response.data.error || ('Failed to add summary to dashboard ' + dash.titleText), reason);
        // keeps the dialog open so the user can pick another dashboard
        throw reason;
      });
  }

  // the template is expanded into a group of graphs on apply, so there is no item to keep in sync,
  // list locally or export to Grafana
  protected updateInDashboard() { return Promise.resolve(); }

  protected updateItem() { /* no local item list */ }

  protected addItem() { /* no local item list */ }

  protected addGrafana() { /* Grafana panel is hidden */ }

  protected postToGrafana() { return Promise.resolve(); }

  protected showItemInDashboardWarn() { return false; }
}
